import styled from "styled-components";
import { colors } from "src/styles/theme";

export const Container = styled.div<{ $stepsXpadding?: string }>`
  width: 100%;
  height: 186px;
  background: #f0f0f4;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  h4 {
    width: 100%;
    color: #1a1a1a;
    text-align: center;
    font-size: 16px; /* 기본 크기 (400px 이하) */
    font-weight: 700;
    line-height: 22px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    /* 400px 이상일 때 폰트 크기 증가 */
    @media (min-width: 460px) {
      font-size: 17px;
    }

    /* 600px 이상일 때 폰트 크기 증가 */
    @media (min-width: 600px) {
      font-size: 18px;
    }

    .title-logo {
      height: 24px;
      width: auto;
      object-fit: contain;
    }

    /* 반응형 로고 크기 */
    .stepper-logo {
      width: 55px !important; /* 기본 크기 (540px 이하) */
      height: auto !important;
      object-fit: contain !important;
    }

    @media (min-width: 354px) {
      .stepper-logo {
        width: 70px !important;
      }
    }
    /* 540px 이상일 때 로고 크기 증가 */
    @media (min-width: 540px) {
      .stepper-logo {
        width: 120px !important;
      }
    }
  }

  .steps {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
  }
`;

export const Step = styled.div`
  display: flex;
  align-items: center;

  &.inactive {
    .btn {
      background-color: white;
      .icon-box {
        color: #898989;
      }
    }
    .line {
      border-bottom-color: ${colors.gray.first};
    }
  }

  &.dotted {
    .line {
      border-bottom-style: dotted;
    }
  }

  &.error {
    .btn {
      background-color: red !important;
    }
    .line {
      border-bottom-color: ${colors.gray.first};
    }
  }

  .btn {
    background: #fdfdfd;

    border-radius: 5px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon-box {
      width: 50px;
      height: 50px;
      color: black;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .label-section {
      font-size: 14px;
      font-weight: 400;
      color: #1a1a1a;
      display: flex;
      justify-content: center;
      width: 60px;
      position: absolute;
      left: 50%;
      bottom: -10px;
      transform: translate(-50%, 100%);
    }
    .label-section3 {
      font-size: 14px;
      font-weight: 400;
      color: #1a1a1a;
      display: flex;
      justify-content: center;
      width: 90px;
      position: absolute;
      left: 50%;
      bottom: -10px;
      transform: translate(-50%, 100%);
      text-align: center;
    }
  }

  .line {
    width: 100%;
    min-width: 10px;
    height: 0; /* 선 높이는 보더로 표현 */
    border-top: 2px dashed #004b49; /* 점선 */
    align-self: center;
    margin: 0 2px;
    box-shadow: none;
  }
`;
